/**
 * Strips the http/https protocol from a full domain
 * @param string host A domain name including protocol
 */
export const removeProtocol = (host: string = ''): string => {
  return host.replace(/^https?\:\/\//i, '');
};
